import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, Copy, Mail, MessageCircle } from "lucide-react";
import { streamPost } from "../lib/stream";
import { SelectField, TextField } from "./Field";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const SCOPI = [{ value: "scadenza", label: "Avviso scadenza" }, { value: "rinnovo", label: "Proposta rinnovo / estensione" }, { value: "benvenuto", label: "Benvenuto e riepilogo" }];
const CANALI = [{ value: "email", label: "Email" }, { value: "whatsapp", label: "WhatsApp" }];

export const MessaggioDialog = ({ open, onClose, garanzia }) => {
  const [scopo, setScopo] = useState(garanzia?.stato === "attiva" ? "benvenuto" : "scadenza");
  const [canale, setCanale] = useState("email");
  const [istruzioni, setIstruzioni] = useState("");
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const c = garanzia?.cliente || {};

  const generate = async () => {
    setText(""); setLoading(true);
    try { await streamPost("/ai/messaggio", { garanzia_id: garanzia.id, scopo, canale, istruzioni }, (ev) => ev.t && setText((p) => p + ev.t)); }
    catch (e) { toast.error(e.message); }
    finally { setLoading(false); }
  };

  const subject = (text.match(/^Oggetto:\s*(.*)$/m) || [])[1] || "";
  const bodyText = text.replace(/^Oggetto:.*\n+/m, "");
  const phone = (c.telefono || "").replace(/[^\d]/g, "");

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-2xl overflow-y-auto" data-testid="messaggio-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Genera messaggio al cliente</DialogTitle>
          <DialogDescription>Testo scritto da Gemini sui dati della garanzia. Rileggi sempre prima di inviare.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          <SelectField label="Scopo" value={scopo} onChange={setScopo} options={SCOPI} testId="messaggio-scopo-select" />
          <SelectField label="Canale" value={canale} onChange={setCanale} options={CANALI} testId="messaggio-canale-select" />
          <TextField label="Istruzioni aggiuntive (opzionale)" value={istruzioni} onChange={setIstruzioni} testId="messaggio-istruzioni-input" className="sm:col-span-2" placeholder="es. tono più informale, citare il tagliando" />
        </div>
        <Button onClick={generate} disabled={loading} className="bg-[#B08D57] hover:bg-[#96764A]" data-testid="messaggio-genera-btn">
          {loading ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Sparkles className="mr-1 h-4 w-4" />} {text ? "Rigenera" : "Genera"}
        </Button>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={12} placeholder="Il messaggio apparirà qui…" data-testid="messaggio-output" />
        {text && !loading && (
          <div className="flex flex-wrap gap-2">
            <Button variant="outline" size="sm" onClick={() => { navigator.clipboard.writeText(text); toast.success("Copiato"); }} data-testid="messaggio-copy-btn"><Copy className="mr-1 h-4 w-4" /> Copia</Button>
            {canale === "email" && c.email && (
              <Button variant="outline" size="sm" asChild data-testid="messaggio-mailto-btn">
                <a href={`mailto:${c.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(bodyText)}`}><Mail className="mr-1 h-4 w-4" /> Apri email</a>
              </Button>
            )}
            {canale === "whatsapp" && phone && (
              <Button variant="outline" size="sm" asChild data-testid="messaggio-whatsapp-btn">
                <a href={`https://wa.me/${phone.startsWith("39") ? phone : `39${phone}`}?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer"><MessageCircle className="mr-1 h-4 w-4" /> Apri WhatsApp</a>
              </Button>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
